import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "xml:space": "preserve",
  id: "Layer_1",
  x: "0",
  y: "0",
  version: "1.1",
  viewBox: "0 0 92.2 65"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M66.5 0H52.4l25.7 65h14.1zM25.7 0 0 65h14.4l5.3-13.6h26.9L51.8 65h14.4L40.5 0zm-1.4 39.3 8.8-22.8 8.8 22.8z",
      style: {"fill":"#181818"}
    }, null, -1)
  ]))]))
}
export default { render: render }